import { ReactNode } from "react";

export const TextTruncated = ({
  lines,
  style,
  lineHeight = "1.2em",
  children,
}: {
  lines: number;
  style?: React.CSSProperties;
  lineHeight?: string | number;
  children: ReactNode;
}) => {
  const styles: React.CSSProperties = {
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    textOverflow: "ellipsis",
    WebkitLineClamp: lines,
    whiteSpace: "normal",
    lineHeight,
    height:
      typeof lineHeight === "number"
        ? `${lineHeight * lines}px`
        : `calc(${lineHeight} * ${lines})`,
    width: "100%",
    wordBreak: "break-word",
    ...style,
  };
  return <div style={styles}>{children}</div>;
};
